import { render } from "./EmailVerificationPage.vue?vue&type=template&id=4f93e178&scoped=true"
import script from "./EmailVerificationPage.vue?vue&type=script&lang=js"
export * from "./EmailVerificationPage.vue?vue&type=script&lang=js"

import "./EmailVerificationPage.vue?vue&type=style&index=0&id=4f93e178&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f93e178"]])

export default __exports__